import React from 'react';

const AboutCard2 = ({ title, desc, image, index }) => {
  return (
    <div className={`ab-card2 ${index >1 ? 'reverse' : ''}`}>
      <div className='ab-card2-text'>
        <h4>{title}</h4>
        <svg width="90%" height="3">
          <line x1="0" y1="0" x2="100%" y2="0" stroke="white" strokeWidth="2" />
        </svg>
        <p>{desc}</p>
      </div>
      <div className='ab-card2-img'>
        <img src={image} alt={title} />
      </div>
    </div>
  );
};

export default AboutCard2;
